/* eslint-disable filenames/match-exported -- TODO: fix this file */
import { lazy, useState } from 'react';
import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { push as navigateTo } from 'connected-react-router';
import { useTranslation } from 'react-i18next';
import { State } from 'reducers';
import { getBuildingByUrlSlug, getBuildingUsers, HasUrlSlug } from 'selectors/buildingsSelectors';
import { getCurrentUserId } from 'selectors/sessionSelectors';
import { unassignBuildingUserRequest } from 'actions/buildingUserActions';
import { UserList } from 'ui/users/userList/UserList';
import { useRouter } from 'util/reactRouterHooks';
import { User } from 'shared/models';
import { Dictionary } from 'lodash';
import { useSession } from 'hooks';
import { Permission } from 'shared/permissions';
import { AssignUserDialog } from 'ui/admin/users/assignUserDialog/AssignUserDialog';

require('./buildingUsersPage.css');

const LazyBuildingUsersAdminRouter = lazy(async () => import('../BuildingUsersAdminRouter'));

const marginBottom = {
    marginBottom: '2em',
};

const noUsers: Dictionary<User> = {};

export const BuildingUsersPage = () => {
    const { t } = useTranslation();
    const { match } = useRouter<HasUrlSlug>();
    const { urlSlug } = match.params;

    const [ assignUserDialogVisible, setAssignUserDialogVisible ] = useState(false);

    const building = useSelector((state: State) => getBuildingByUrlSlug(state, match.params));
    const buildingId = building && building.id;

    const myUserId = useSelector(getCurrentUserId)!;
    const { hasPermission } = useSession();
    const users = useSelector((state: State) => (buildingId && getBuildingUsers(state, { buildingId })) || noUsers);

    const dispatch = useDispatch();

    const handleClickAddNew = useCallback(() => {
        dispatch(navigateTo(`/buildings/${urlSlug}/settings/users/new`));
    }, [ dispatch, urlSlug ]);

    const handleClickUnassign = useCallback((userId: string) => () => {
        if (buildingId) {
            dispatch(unassignBuildingUserRequest({ buildingId, userId }));
        }
    }, [ dispatch, buildingId ]);

    const makeLink = useCallback((userId: string) =>
        myUserId === userId
            ? '/profile' // user edits his own data via profile page
            : `/buildings/${urlSlug}/settings/users/${userId}`
    , [ myUserId, urlSlug ]);

    const order = users && Object.keys(users);
    return (
        <div id="building-users-page" className="page">
            <div>
                { hasPermission(buildingId, Permission.CreateUser) &&
                    <button type="button" className="ui basic button" style={ marginBottom } onClick={ handleClickAddNew }>
                        { t('COMMAND.ADD_NEW_USER') }
                    </button>
                }
                { hasPermission(buildingId, Permission.AssignUser) &&
                    <button type="button" className="ui basic button" style={ marginBottom } onClick={ () => setAssignUserDialogVisible(true) }>
                        { t('COMMAND.ASSIGN_EXISTING_USER') }
                    </button>
                }
            </div>
            <UserList
                buildingId={ buildingId }
                users={ users }
                order={ order }
                makeLink={ makeLink }
                onClickUnassign={ handleClickUnassign }
            />

            <AssignUserDialog
                visible={ assignUserDialogVisible }
                onHide={ () => setAssignUserDialogVisible(false) }
            />

            { hasPermission(buildingId, Permission.CreateUser) &&
                <LazyBuildingUsersAdminRouter/>
            }
        </div>
    );
};
